<template>
  <span
    :class="['popular-combos-odds', {
      active,
      'swiper-web': isWeb,
      'popular-combos-odds--up': isUp,
      'popular-combos-odds--down': isDown
    }]"
    @click="handleSelect"
  >
    <i
      v-if="isUp || isDown"
      :class="['m-icon-arrow', {
        'up': isUp,
        'down': isDown
      }]"
    />
    {{ odds }}
  </span>
</template>

<script>
import { ref, computed, watch, getCurrentInstance } from '@vue/composition-api'
import { storeToRefs } from 'pinia'
import { useDetailStore } from '@ms/stores/matchDetail/index'
import { useAuthStore } from '@ms/stores/auth'
import { isSelectedCombosSelection } from '@ms/stores/betslip/func'

const time = 5000

export default {
  name: 'PopularOdds',
  props: {
    event: {
      type: Object,
      default: () => ({})
    },
    selections: {
      type: Array,
      default: () => []
    },
    odds: {
      type: [Number, String],
      default: ''
    },
    selectionList: {
      type: Array,
      default: () => []
    }
  },
  setup(props, { emit }) {
    const { proxy: vm } = getCurrentInstance()

    const timer = ref(null)

    const isUp = ref(false)
    const isDown = ref(false)

    const { loading } = storeToRefs(useDetailStore())

    watch(
      () => props.odds,
      (val, oldVal) => {
        if (val && oldVal) {
          if (val > oldVal) {
            isUp.value = true
            timer.value && clearTimeout(timer.value)
            timer.value = setTimeout(() => {
              isUp.value = false
            }, time)
          } else {
            isDown.value = true
            timer.value && clearTimeout(timer.value)
            timer.value = setTimeout(() => {
              isDown.value = false
            }, time)
          }
        }
      }
    )

    const active = computed(() => isActive())

    const handleSelect = () => {
      if (loading.value) return false
      if (!useAuthStore().loginStatus) {
        vm.$login()
        return false
      }

      emit('select')
      const active = isActive()
      getConflict(!active)
    }

    const getConflict = async (isDelete = false) => {
      try {
        const marketInfo = props.selections.map((x) => {
          return {
            outcome: x.outcomes[0],
            market: x
          }
        })
        !isDelete && useDetailStore().deteleConflictMarket()
        await useDetailStore().getConflictMarkets(marketInfo, isDelete, '', !isDelete)
      } catch (error) {
        console.error(error)
      }
    }

    const isActive = () => {
      return isSelectedCombosSelection(props.selectionList, {
        event: props.event,
        combos: { selections: props.selections, odds: props.odds }
      })
    }

    return {
      isUp,
      isDown,
      active,
      isWeb: process.env.PLATFORM === 'desktop',
      handleSelect
    }
  }
}
</script>

<style lang="scss" scoped>
@use "~wap/common/style/mixin";
@use "~wap/common/style/vars";

.popular-combos-odds {
  position: relative;
  min-width: 53px;
  height: 40px;
  box-sizing: border-box;
  padding: 0 4px;
  border-radius: 4px;
  margin: 9px 0 0 14px;
  background: #333;
  color: #ffca27;
  cursor: pointer;
  font-size: 12px;
  font-weight: 500;
  line-height: 40px;
  text-align: center;

  &.active {
    background-color: #ffca27;
    color: #333;
  }

  &--up {
    &::before {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 2px;
      border-radius: 2px 2px 0 0;
      background: vars.$green;
      content: "";
    }
  }

  &--down {
    &::after {
      position: absolute;
      bottom: 0;
      left: 0;
      width: 100%;
      height: 2px;
      border-radius: 0 0 2px 2px;
      background: #e61818;
      content: "";
    }
  }

  .m-icon-arrow {
    position: absolute !important;
    right: 50%;
    margin-right: -4px;

    @include mixin.m-icon-trangle(4px);

    &.up {
      top: 2px;

      &::before {
        border-bottom-color: vars.$green;
      }
    }

    &.down {
      bottom: 2px;

      &::before {
        border-top-color: vars.$red;
      }
    }
  }
}

.swiper-web {
  .popular-combos-odds {
    background: #404040;

    &.active {
      background-color: #ffca27;
      color: #333;
    }

    &:hover {
      background: #000;
      color: #ffca27;
    }
  }
}
</style>
